import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;

    cursor: pointer;
    
    width: 292px;
    height: 42px;

    padding-left: 16px;

    color: ${window?.settings?.secondary_color ?? '#04333b'};
    border: 1px solid #EEEEEE;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.08);
    border-radius: 8px;

    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    /* identical to box height, or 143% */

    letter-spacing: 0.1px;
    text-decoration-line: underline;

    &:hover {
      border: 1px solid  ${theme?.colour?.primary};
    }
  `}
`;
